module.exports = __webpack_public_path__ + "dash_20_app_assets/img/tripadvisorhow.c5801fa4.png";